import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserRole } from './views/pages/_api-service/models';

@Injectable({
  providedIn: 'root'
})
export class AppService {


  constructor(private router: Router) { }

  getisLoggedIn(): boolean {

    if (localStorage.getItem("isLoggedIn") == "true")
      return true;
    else {
      localStorage.setItem("isLoggedIn", "false");
      return false;
    }
  }

  setisLoggedIn(): void {
    localStorage.setItem("isLoggedIn", "true");
  }

  updateisLoggedIn(value:string): void {
    localStorage.setItem("isLoggedIn", value);
  }




  setUserId(value:string): void {
    localStorage.setItem("userId", value);
  }

  getUserId(): string {
    return localStorage.getItem("userId");
  }

  setPatientId(value:string): void {
    localStorage.setItem("patientId", value);
  }

  getPatientId(): string {
    return localStorage.getItem("patientId");
  }

  setUserRole(value:string): void {
    localStorage.setItem("userrole", value);
  }

  getUserRole(): UserRole | null {
    const role = localStorage.getItem("userrole");
    if (!role) return null;
    return role as UserRole;
  }

  setUsername(value:string): void {
    localStorage.setItem("username", value);
  }

  getUsername():string {
    return localStorage.getItem("username");
  }

  setEmail(value:string):void {
    localStorage.setItem("email", value);
  }

  getEmail():string {
    return localStorage.getItem("email");
  }

  setName(value:string):void {
    localStorage.setItem("name", value);
  }

  getName():string {
    return localStorage.getItem("name");
  }

}
